import request from '@/utils/request'

export function list(data) {
  return request({
    url: '/system/dict/' + data.dictId + '/detail',
    method: 'get'
  })
}

export function listByDictType(data) {
  const params = {
    pageNum: 0,
    pageSize: 9999
  }
  return request({
    url: '/system/dict/' + data + '/detail/dictTypeALl',
    method: 'get',
    params
  })
}

export function add(data) {
  console.info('dictData==>', data)
  return request({
    url: '/system/dict/' + data.dictId + '/detail',
    method: 'post',
    data
  })
}

export function edit(data) {
  return request({
    url: '/system/dict/' + data.dictId + '/detail/' + data.id,
    method: 'put',
    data
  })
}

export function del(data) {
  return request({
    url: '/system/dict/data/' + data + '/detail/' + data,
    method: 'delete'
  })
}

export function delDetail(dictTypeId, dictDataId) {
  return request({
    url: `/system/dict/${dictTypeId}/detail/${dictDataId}`,
    method: 'delete'
  })
}

export default {
  add,
  edit,
  del,
  delDetail
}
